import script from "./UserArtistArtWorkList.vue?vue&type=script&setup=true&lang=js"
export * from "./UserArtistArtWorkList.vue?vue&type=script&setup=true&lang=js"

import "./UserArtistArtWorkList.vue?vue&type=style&index=0&id=93f38720&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93f38720"]])

export default __exports__